/** @format */

import {styled, TextField, Typography} from '@mui/material';

export const Title = styled(Typography)({
  color: '#F1F1F1',
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '160%',
  letterSpacing: '0.15px',
});

export const Description = styled(Typography)({
  color: '#A1A1A1',
});

export const Input = styled(TextField)(({theme}) => ({
  display: 'flex',
  width: '350px',
  marginTop: theme.spacing(2),
}));
